{
  "AUTH_INVALID_CREDENTIALS": "Invalid email or password.",
  "AUTH_ACCOUNT_BLOCKED": "Your account is blocked.",
  "AUTH_ACCOUNT_INACTIVE": "Your account is inactive. Please contact support.",
  "AUTH_USER_NOT_FOUND": "User not found.",
  "AUTH_TWO_FACTOR_REQUIRED": "A verification code is required.",
  "AUTH_TWO_FACTOR_CODE_INVALID": "Invalid verification code.",
  "AUTH_TOKEN_INVALID": "Invalid token.",
  "AUTH_TOKEN_EXPIRED": "The token has expired.",
  "AUTH_TOKEN_REQUIRED": "A token is required.",
  "AUTH_LOGOUT_SUCCESS": "You have been logged out.",
  "AUTH_PASSWORD_RESET_REQUESTED": "If the email exists, you will receive a link to set your password.",
  "AUTH_RESET_TOKEN_INVALID": "The token is invalid or has expired.",
  "AUTH_PASSWORD_CHANGED": "Password changed successfully.",
  "AUTH_PASSWORD_INCORRECT": "Incorrect password.",
  "AUTH_TWO_FACTOR_ALREADY_ENABLED": "Two-factor authentication is already enabled.",
  "AUTH_TWO_FACTOR_SETUP_EXPIRED": "The setup session has expired.",
  "AUTH_CODE_INVALID": "Invalid code.",
  "AUTH_TWO_FACTOR_ENABLED": "Two-factor authentication enabled successfully.",
  "AUTH_TWO_FACTOR_DISABLED": "Two-factor authentication disabled successfully.",
  "AUTH_DEEP_LINK_INVALID": "The deep link token is invalid or has expired.",
  "AUTH_DEEP_LINK_USED": "The token has already been used or has expired.",
  "AUTH_MAGIC_LINK_SENT": "If the email exists, the magic link has been sent.",
  "AUTH_MAGIC_LINK_INVALID": "The magic link is invalid or has expired.",
  "AUTH_MAGIC_LINK_LOGIN_SUCCESS": "Logged in with magic link successfully.",
  "AUTH_EMAIL_REQUIRED": "Email is required.",
  "AUTH_TOO_MANY_LOGIN_ATTEMPTS": "Too many login attempts. Please try again in a few minutes.",
  "AUTH_OAUTH_NOT_CONFIGURED": "{{provider}} OAuth is not configured.",
  "AUTH_OAUTH_PROVIDER_UNSUPPORTED": "Unsupported provider.",
  "AUTH_OAUTH_PROVIDER_INVALID": "Invalid provider.",
  "AUTH_OAUTH_CODE_REQUIRED": "An authorization code is required.",
  "AUTH_OAUTH_STATE_REQUIRED": "The state parameter is required.",
  "AUTH_OAUTH_STATE_INVALID": "Invalid state parameter.",
  "AUTH_OAUTH_CODE_OR_STATE_REQUIRED": "The code or state parameter is required.",
  "AUTH_SOCIAL_CALLBACK_OK": "The social login callback endpoint is working.",
  "AUTH_MFA_METHOD_UNAVAILABLE": "Method not available.",
  "AUTH_MFA_CODE_COOLDOWN": "Please wait {{seconds}} seconds before requesting another code.",
  "AUTH_MFA_PHONE_MISSING": "No phone number on file.",
  "AUTH_MFA_CODE_SENT": "Code sent.",
  "AUTH_MFA_TOO_MANY_ATTEMPTS": "Too many attempts. Please start the login again.",
  "AUTH_MFA_METHOD_ALREADY_VERIFIED": "This method has already been verified.",
  "AUTH_MFA_CODE_INVALID": "Invalid code or password.",
  "AUTH_MFA_SESSION_EXPIRED": "Your session has expired. Please start the login again.",
  "AUTH_MFA_SESSION_INVALID": "Invalid session. Please start the login again.",
  "AUTH_MFA_SESSION_UNAVAILABLE": "We could not continue the login. Please try again in a moment.",
  "AUTH_WEBHOOK_TOKEN_INVALID": "Invalid webhook token.",
  "AUTH_WEBHOOK_UNAVAILABLE": "The users webhook is unavailable: signature not configured.",
  "AUTH_WEBHOOK_SIGNATURE_REQUIRED": "A webhook signature is required.",
  "AUTH_WEBHOOK_SIGNATURE_INVALID": "Invalid webhook signature.",
  "AUTH_WEBHOOK_SOURCE_REQUIRED": "The webhook source is required.",
  "AUTH_WEBHOOK_USERS_REQUIRED": "Invalid payload: the users array is required.",
  "AUTH_WEBHOOK_FIELDS_REQUIRED": "Name and email are required.",
  "AUTH_WEBHOOK_USER_EXISTS": "A user with this email already exists.",
  "AUTH_WEBHOOK_USER_CREATE_FAILED": "Failed to create the user.",
  "AUTH_WEBHOOK_USER_CREATED": "User created successfully via webhook.",
  "AUTH_WEBHOOK_PING_OK": "The webhook endpoint is working.",
  "AUTH_EMAIL_INVALID": "Invalid email.",
  "AUTH_PASSWORD_TOO_SHORT": "Password must be at least 8 characters long.",
  "AUTH_PASSWORD_WEAK": "Password must contain at least one uppercase letter, one lowercase letter and one number.",
  "AUTH_REFRESH_TOKEN_REQUIRED": "A refresh token is required.",
  "AUTH_TWO_FACTOR_CODE_LENGTH": "The code must be 6 digits long.",
  "AUTH_TWO_FACTOR_BACKUP_CODE_LENGTH": "The code must be 6 to 8 characters long.",
  "AUTH_MFA_SEND_METHOD_INVALID": "The method must be email or sms.",
  "AUTH_MFA_METHOD_INVALID": "Invalid method.",
  "USER_NOT_FOUND": "User not found.",
  "USER_EMAIL_IN_USE": "This email is already in use.",
  "USER_CPF_IN_USE": "This CPF is already in use.",
  "USER_BLOCKED": "User is blocked.",
  "USER_CURRENT_PASSWORD_INCORRECT": "Current password is incorrect.",
  "USER_DELETED": "User deleted successfully.",
  "USER_NAME_TOO_SHORT": "Name must be at least 2 characters long.",
  "USER_CPF_INVALID": "CPF must have 11 numeric digits.",
  "USER_PHONE_INVALID": "Phone number must have 10 or 11 digits.",
  "USER_PHONE_INTERNATIONAL_INVALID": "Phone number must be in international format (+ and 8 to 15 digits).",
  "TERMS_IP_REQUIRED": "The IP address is required.",
  "TERMS_CONTRACT_FILE_TYPE_INVALID": "Only PDF or DOC/DOCX files are allowed.",
  "TERMS_CONTRACT_FILE_TOO_LARGE": "The file must be at most {{maxMb}} MB.",
  "ONBOARDING_PROGRESS_NOT_FOUND": "Onboarding progress not found.",
  "ONBOARDING_PROGRESS_ALREADY_EXISTS": "Onboarding progress already exists for this user.",
  "ONBOARDING_TEMPLATE_NOT_FOUND": "Template not found.",
  "DEVFLIX_SSO_STUDENT_NOT_FOUND": "Active student not found.",
  "DEVFLIX_SSO_EMAIL_NOT_VERIFIED": "Confirm your email in the members area before signing in to DevFlix.",
  "DEVFLIX_SSO_CODE_INVALID": "Invalid authorization code.",
  "DEVFLIX_SSO_NOT_CONFIGURED": "The DevFlix integration is not configured with a client, secret and strong redirects.",
  "DEVFLIX_SSO_CLIENT_NOT_AUTHORIZED": "DevFlix client or redirect not authorized.",
  "DEVFLIX_SSO_CLIENT_UNAUTHENTICATED": "Client not authenticated.",
  "DEVFLIX_SSO_SCOPE_INVALID": "Invalid DevFlix scope.",
  "PLATFORM_OPERATOR_NOT_FOUND": "Operator not found.",
  "PLATFORM_OPERATOR_INACTIVE": "Operator is inactive.",
  "PLATFORM_TENANT_NOT_FOUND": "No members area serves this address.",
  "PLATFORM_SCHOOL_NAME_REQUIRED": "Enter the school name.",
  "PLATFORM_ADMIN_EMAIL_REQUIRED": "Enter the school admin email.",
  "PLATFORM_ADMIN_PASSWORD_TOO_SHORT": "The initial admin password must be at least {{min}} characters long.",
  "PLATFORM_SUBDOMAIN_INVALID": "Invalid subdomain.",
  "PLATFORM_SUBDOMAIN_RESERVED": "The subdomain \"{{slug}}\" is reserved.",
  "PLATFORM_SUBDOMAIN_TAKEN": "The subdomain \"{{slug}}\" is already in use.",
  "PLATFORM_SUBDOMAIN_UNAVAILABLE": "Could not derive an available subdomain from \"{{source}}\".",
  "PLATFORM_TENANT_SUSPENDED": "Client suspended.",
  "PLATFORM_TENANT_BLOCKED": "This members area is blocked. Contact support.",
  "PLATFORM_TENANT_REACTIVATED": "Client reactivated.",
  "AUTH_INVITE_INVALID": "Access link is invalid or already used.",
  "AUTH_INVITE_EXPIRED": "Access link has expired. Request a new one.",
  "AUTH_PASSWORD_NOT_SET": "You haven't set your password yet. Use the link sent to your email or recover access with \"Forgot password?\".",
  "PLATFORM_PRODUCER_WEBHOOK_SIGNATURE_INVALID": "Invalid webhook signature."
}
